import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { VenuePreset } from '@/domain/project-venue-presets/entities/project-venue-presets.entity.ts';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const getVenuePresets = createAppAsyncThunk(
  'projectVenuePresets/getVenuePresets',
  async (
    _,
    { extra: { projectVenuePresetsGateway, snackbarGateway }, getState },
  ): Promise<Array<VenuePreset>> => {
    try {
      const projectId = selectCurrentProjectVenue(getState())?.id || -1;
      return await projectVenuePresetsGateway.getAll(projectId);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetVenueDates.Message.error'));
}
